import React, { FC } from 'react';
import { User } from 'api/models';
import { Avatar } from 'components/atoms/avatar';
import { NameCell } from 'components/organisms/timesheets/common/cells/name-cell';
import { fullName } from 'utils/full-name';
import { getThumbnailUrl } from 'utils/get-thumbnail-url';
import { CellWrapper, TextWrapperWithEllipsis } from './component';

interface Props
  extends Pick<User, 'photoUrl' | 'firstName' | 'lastName' | 'role'> {
  onWrapperClick: () => void;
}
export const UserCellForUsersView: FC<Props> = ({
  firstName,
  lastName,
  photoUrl,
  role,
  onWrapperClick,
}) => {
  const name = fullName({ lastName, firstName });

  return (
    <CellWrapper onClick={onWrapperClick}>
      <NameCell
        logo={<Avatar src={getThumbnailUrl(photoUrl)} name={name} />}
        primaryText={
          <TextWrapperWithEllipsis data-cy={name}>
            {name}
          </TextWrapperWithEllipsis>
        }
        secondaryText={
          <TextWrapperWithEllipsis>
            {role?.roleName ?? ''}
          </TextWrapperWithEllipsis>
        }
      />
    </CellWrapper>
  );
};
